import { render, staticRenderFns } from "./RestoreChannel.vue?vue&type=template&id=4dcee6ae&scoped=true"
import script from "./RestoreChannel.vue?vue&type=script&lang=js"
export * from "./RestoreChannel.vue?vue&type=script&lang=js"
import style0 from "./RestoreChannel.vue?vue&type=style&index=0&id=4dcee6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcee6ae",
  null
  
)

export default component.exports